import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const dependencyAdapter = createEntityAdapter();

const initialState = dependencyAdapter.getInitialState({
	status: "idle",
	error: null,
});

const dependencySlice = createSlice({
	name: "dependency",
	initialState,
	reducers: {
		dependencyAdded(state, action) {
			dependencyAdapter.addOne(state, action.payload);
		},
		dependencyEdited(state, action) {
			dependencyAdapter.upsertOne(state, action.payload);
		},
		dependencyReceived(state, action) {
			dependencyAdapter.setAll(state, action.payload);
		},
	},
});

export const { dependencyAdded, dependencyEdited, dependencyReceived } =
	dependencySlice.actions;

/*
SELECTORS
*/
export const {
	selectAll: selectAllDependencies,
	selectById: selectDependencyById,
} = dependencyAdapter.getSelectors((state) => state.dependencies);

export const selectDependenciesError = (state) => state.dependencies.error;

export default dependencySlice.reducer;
